import LoginScreen from '@Containers/Login';
import { LoginProps } from '@Store/auth/types';

const Login = (props: LoginProps) => <LoginScreen {...props} />;

export default Login;
